import { MutableRefObject } from 'react';
import { screenStore } from 'stores/ScreenStore';

export const removeBottomSearchResultFromTheMap = () => {
  const searchResults = document.querySelectorAll('[class*="SearchResult_container"][data-id]');
  for (let i = 0; i < searchResults.length; i++) {
    const searchResult = searchResults[i] as HTMLElement;
    searchResult.style.cssText = '';
  }
}

const scrollIntoView = (id: number, previousMarker: MutableRefObject<HTMLElement | null>) => {
  if (previousMarker.current) {
    previousMarker.current.style.boxShadow = '';
    previousMarker.current.style.background = '#fff';
    previousMarker.current.style.border = '1px solid #eaeaea';
  }

  const selectedSearchResult = document.querySelector(`[data-id="${id}"]`) as HTMLElement;

  const { isMobile, isTablet } = screenStore;

  // @ts-ignore
  if (isTablet || isMobile) {
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '1000vw';
    overlay.style.height = '100vh';
    overlay.style.zIndex = '150';
    overlay.addEventListener('click', () => {
        removeBottomSearchResultFromTheMap();
        document.querySelector('.leaflet-pane.leaflet-marker-pane')?.removeChild(overlay);
    });
    document.querySelector('.leaflet-pane.leaflet-marker-pane')?.appendChild(overlay);

    removeBottomSearchResultFromTheMap();

    selectedSearchResult.style.position = 'absolute';
    selectedSearchResult.style.left = '50%';
    selectedSearchResult.style.bottom = '0';
    selectedSearchResult.style.transform = 'translate(-50%)';
    selectedSearchResult.style.width = '90vw';
    selectedSearchResult.style.zIndex = '3';
    selectedSearchResult.style.flexDirection = 'row';

    const img = document.querySelector(`[data-id="${id}"] [class*="Slider_container"]`) as HTMLElement;
    img.style.width = "46%";

    if (isMobile) {
      selectedSearchResult.style.height = '225px';

      const title = document.querySelector(`[data-id="${id}"] [class*="SearchResult_container__content__title"]`) as HTMLElement;
      if (title) {
        title.style.maxHeight = "66px";
        title.style.overflow = "hidden";
        title.style.fontSize = "15px";
      }
  
      const secondPrice = document.querySelector(`[data-id="${id}"] [class*="Prices_container"]:not(:first-child)`) as HTMLElement;
      if (secondPrice) {
        secondPrice.style.display = "none";
      }
    }
    // @ts-ignore
  } else if (window.CRO_899 == 3) {
    removeBottomSearchResultFromTheMap();

    selectedSearchResult.style.position = "absolute";
    selectedSearchResult.style.left = "2%";
    selectedSearchResult.style.top = "22%";
    selectedSearchResult.style.width = "420px";
    selectedSearchResult.style.minWidth = "330px";
    selectedSearchResult.style.height = "680px";
    selectedSearchResult.style.maxHeight = "90vh";
    selectedSearchResult.style.zIndex = "3";
    selectedSearchResult.style.flexDirection = "column";

    const img = document.querySelector(`[data-id="${id}"] [class*="Slider_container"]`) as HTMLElement;
    img.style.width = "100%";
    img.style.height = "36%";

    const content = document.querySelector(`[data-id="${id}"] [class*="SearchResult_container__content"]`) as HTMLElement;
    content.style.width = "100%";
    content.style.setProperty("padding", "0", "important");

    const contentChildren: NodeListOf<HTMLElement> = document.querySelectorAll(`[data-id="${id}"] [class*="SearchResult_container__content"] > *:not(:last-child)`) as NodeListOf<HTMLElement>;
    contentChildren.forEach((element) => {
      element.style.marginLeft = "25px";
      element.style.marginRight = "25px";
    })

    const header = document.querySelector(`[data-id="${id}"] [class*="SearchResult_container__content"] a`) as HTMLElement;
    header.style.width = "auto";
    header.style.marginTop = "15px";

    const btnContainer = document.querySelector(`[data-id="${id}"] [data-space-id="${id}"]`) as HTMLElement;
    btnContainer.style.width = "100%";
    btnContainer.style.padding = "15px 25px";
    btnContainer.style.boxShadow = "0 4px 14px rgba(0,0,0,.13)";
    btnContainer.style.margin = "0";
    btnContainer.style.position = "absolute";
    btnContainer.style.bottom = "0";
    btnContainer.style.background = "white";

    const btn = document.querySelector(`[data-id="${id}"] .quickQuoteButton`) as HTMLElement;
    btn.style.width = "100%";
    btn.style.height = "40px";
  } else if (selectedSearchResult) {
    selectedSearchResult.scrollIntoView({
      // behavior: 'smooth', // works in chrome if remove 'smooth'
      block: 'center',
    });

    selectedSearchResult.style.boxShadow = '0px 4px 10px rgba(0, 0, 0, 0.24)';
    selectedSearchResult.style.background = '#F5F6F7';
    selectedSearchResult.style.border = '1px solid #F5F6F7';
    
    previousMarker.current = selectedSearchResult;
  }
}

export default scrollIntoView;
